<template>
  <div class="container-fluid bg-white py-3">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-4">
          <notifications />
          <h3 class="pb-3">
            Manage your subscription
          </h3>
          <p v-if="user.type == 'individual' || user.type == 'free'">
            Select your subscription level below.  Remember, paid accounts have access to more details on the Scorecard, personal health resources, and sample menus, along with all the benefits of a free account!
          </p>
          <p v-if="user.type == 'food_service_limited' || user.type == 'food_service_full'">
            Select your subscription level below.  Remember, full access accounts have access to more food service resources!
          </p>
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <div class="status-card shadow col-md-8 col-lg-6 p-3">
          <div class="d-flex justify-content-between">
            <div v-if="plan && subscription">
              <h5>Current Plan: <span class="font-italic">{{ plan.name }}</span></h5>
              <h5>Billed Rate: <span class="font-italic">${{ subscription.billed_rate }}/{{ plan.interval }}</span></h5>
              <h5 v-if="subscription && subscription.coupon">
                Coupon: <span class="badge badge-success">{{ subscription.coupon.name }}</span>
                <span
                  v-if="subscription.coupon.percent_off"
                  class="label text-success"
                >{{ subscription.coupon.percent_off }}% OFF</span>
                <span
                  v-if="subscription.coupon.amount_off"
                  class="label text-success"
                >{{ subscription.coupon.amount_off }} OFF</span>
                <span
                  v-if="subscription.coupon.duration == 'repeating'"
                  class="label text-success"
                >for {{ subscription.coupon.duration_in_months }} months!</span>
                <span
                  v-if="subscription.coupon.duration == 'once'"
                  class="label text-success"
                >your first month!</span>
                <span
                  v-if="subscription.coupon.duration == 'forever'"
                  class="label text-success"
                >FOREVER!</span>
              </h5>
              <h5 v-if="subscription && subscription.ends_at">
                Plan Ends On: <span class="font-italic">{{ moment(subscription.ends_at).format('LL') }}</span>
              </h5>
              <div v-if="subscription">
                <h5>Saved Card: </h5>
                <span class="badge badge-secondary font-italic mock-cc">
                  <div class="card-name">{{ user.pm_type }}</div>
                  <div class="card-digits">{{ user.pm_last_four }}</div>
                </span>
              </div>
            </div>

            <div v-if="!plan && user.type == 'free'">
              <h5>Current Plan: <span class="font-italic">Free</span></h5>
            </div>

            <div v-if="user.has_app_store_subscription">
              <h5>Your subscription is managed through the App Store/Play Store.</h5>
            </div>

            <div v-else-if="!subscription && user.type != 'free'">
              <h5>You need an active subscription for your account type.  Please select a subscription below.</h5>
            </div>

            <div
              v-if="subscription"
              class="update-card-button"
            >
              <router-link
                v-if="subscription"
                :to="{name: 'update-payment'}"
                class="btn btn-success btn-md"
              >
                Update Card
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-4 mb-4">

      <!-- Individual/Free subscriptions -->
      <div
        v-if="user.type == 'individual' || user.type == 'free'"
        class="row d-flex pb-3 pb-sm-5 justify-content-center"
      >
        <div class="col-12 col-md-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Basic
              </h4>
              <h2 class="text-center">
                <span class="plan-price-digit text-success">$0</span>/mo.
              </h2>
            </div>
            <div class="card-body">
              <p><em>Limited access to exclusive posts and recipes and our Health Scorecard.</em></p>
              <div class="d-flex justify-content-center">
                <div>
                  <div><span class="checkmark">&#10004;</span> No monthly fee</div>
                  <div><span class="checkmark">&#10004;</span> Exclusive blog posts and recipes</div>
                  <div><span class="checkmark">&#10004;</span> Limited access to Health Scorecard</div>
                  <div><span class="crossmark">&#10008;</span> Full access to Health Scorecard</div>
                  <div><span class="crossmark">&#10008;</span> Access to Sample Menus</div>
                  <div><span class="crossmark">&#10008;</span> Access to Personal Health Resources</div>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-center align-items-center">
              <div
                v-if="user.type == 'individual' && subscription && !subscription.ends_at"
                class="btn btn-danger btn-md text-light"
                @click="cancel"
              >
                Downgrade To Free
              </div>
              <div
                v-if="user.type == 'free'"
                class="text-muted"
              >
                Current Plan
              </div>
              <div
                v-if="user.type == 'individual' && subscription && subscription.ends_at"
                class="text-muted"
              >
                Goes into effect on {{ moment(subscription.ends_at).format('LL') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4
                v-if="plans && plans.individual"
                class="card-title text-center m-0"
              >
                {{ plans.individual.name }}
              </h4>
              <h2
                v-if="plans && plans.individual"
                class="text-center"
              >
                <span class="plan-price-digit text-success">${{ plans.individual.price }}</span>/{{ plans.individual.interval }}
              </h2>
            </div>
            <div class="card-body">
              <p><em>Full access to Health Scorecard and personal health resources, as well as sample menus.</em></p>
              <div class="d-flex justify-content-center">
                <div class="ml-3">
                  <div><span class="checkmark">&#10004;</span> Exclusive blog posts and recipes</div>
                  <div><span class="checkmark">&#10004;</span> Full access to Health Scorecard</div>
                  <div><span class="checkmark">&#10004;</span> Access to Sample Menus</div>
                  <div><span class="checkmark">&#10004;</span> Access to Personal Health Resources</div>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-center align-items-center">
              <router-link
                v-if="user.type == 'free' && plans.individual"
                :to="{name: 'subscribe', params: {type: 'individual'}}"
                class="btn btn-success btn-md"
              >
                Upgrade Now
              </router-link>
              <div
                v-if="user.type == 'individual' && subscription && !subscription.ends_at"
                class="text-muted"
              >
                Already Signed Up!
              </div>
              <div
                v-if="user.type == 'individual' && subscription && subscription.ends_at"
                class="text-muted mr-3"
              >
                Plan expires on {{ moment(subscription.ends_at).format('LL') }}
              </div>
              <div
                v-if="user.type == 'individual' && subscription && subscription.ends_at"
                class="btn btn-success btn-md"
                @click="resume"
              >
                Resume Subscription
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Food Service Subscriptions -->
      <div
        v-if="user.type == 'food_service_limited' || user.type == 'food_service_full'"
        class="row d-flex pb-3 pb-sm-5 justify-content-center"
      >
        <div class="col-12 col-md-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4
                v-if="plans && plans.food_service_limited"
                class="card-title text-center m-0"
              >
                {{ plans.food_service_limited.name }}
              </h4>
              <h2
                v-if="plans && plans.food_service_limited"
                class="text-center"
              >
                <span class="plan-price-digit text-success">${{ plans.food_service_limited.price }}</span>/{{ plans.food_service_limited.interval }}
              </h2>
            </div>
            <div class="card-body">
              <p><em>Access to limited resources from the following categories</em></p>
              <div class="d-flex justify-content-center">
                <div>
                  <div><span class="checkmark">&#10004;</span> In-Service Education</div>
                  <div><span class="checkmark">&#10004;</span> Facility Signage/Posters</div>
                  <div><span class="checkmark">&#10004;</span> Temperature Logs</div>
                  <div><span class="checkmark">&#10004;</span> Kitchen Forms</div>
                  <div><span class="checkmark">&#10004;</span> Policies & Procedures Manuals<em>limited</em></div>
                  <div><span class="checkmark">&#10004;</span> Serve-Safe Guides</div>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-center align-items-center">
              <router-link
                v-if="!subscription && plans.food_service_limited"
                :to="{name: 'subscribe', params: {type: 'food-service-limited'}}"
                class="btn btn-success btn-md"
              >
                Subscribe
              </router-link>
              <div
                v-if="plans && user.type == 'food_service_full'"
                class="btn btn-danger btn-md text-light"
                @click="swap(plans.food_service_limited.type)"
              >
                Downgrade To Limited
              </div>
              <div
                v-if="user.type == 'food_service_limited' && subscription && !subscription.ends_at"
                class="text-muted"
              >
                Current Plan
              </div>
              <div
                v-if="user.type == 'food_service_limited' && subscription && subscription.ends_at"
                class="text-muted mr-3"
              >
                Plan expires on {{ moment(subscription.ends_at).format('LL') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4
                v-if="plans && plans.food_service_full"
                class="card-title text-center m-0"
              >
                {{ plans.food_service_full.name }}
              </h4>
              <h2
                v-if="plans && plans.food_service_full"
                class="text-center"
              >
                <span class="plan-price-digit text-success">${{ plans.food_service_full.price }}</span>/{{ plans.food_service_full.interval }}
              </h2>
            </div>
            <div class="card-body">
              <p><em>COMPLETE access to resources from 20+ categories</em></p>
              <div class="d-flex justify-content-center">
                <div class="ml-3">
                  <div><span class="checkmark">&#10004;</span> In-Service Education</div>
                  <div><span class="checkmark">&#10004;</span> Facility Signage/Posters</div>
                  <div><span class="checkmark">&#10004;</span> Temperature Logs</div>
                  <div><span class="checkmark">&#10004;</span> Kitchen Forms</div>
                  <div><span class="checkmark">&#10004;</span> Policies & Procedures Manuals</div>
                  <div><span class="checkmark">&#10004;</span> Serve-Safe Guides</div>
                  <div><span class="checkmark">&#10004;</span> <strong>Diet Cards!</strong></div>
                  <div><span class="checkmark">&#10004;</span> Weekly Menu Templates</div>
                  <div><span class="checkmark">&#10004;</span> Patient Handouts</div>
                  <div><span class="checkmark">&#10004;</span> Continuous Quality Manuals</div>
                  <div><span class="checkmark">&#10004;</span> RD Forms for Consulting</div>
                  <div><span class="checkmark">&#10004;</span> Standardized Recipes</div>
                  <div><span class="checkmark">&#10004;</span> PowerPoint Presentations</div>
                  <div><span class="checkmark">&#10004;</span> And many more useful resources ...</div>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-center align-items-center">
              <router-link
                v-if="!subscription && plans.food_service_full"
                :to="{name: 'subscribe', params: {type: 'food-service-full'}}"
                class="btn btn-success btn-md"
              >
                Subscribe
              </router-link>
              <div
                v-if="plans && user.type == 'food_service_limited' && subscription"
                class="btn btn-success btn-md text-light"
                @click="swap(plans.food_service_full.type)"
              >
                Upgrade to Full
              </div>
              <div
                v-if="user.type == 'food_service_full' && subscription && !subscription.ends_at"
                class="text-muted"
              >
                Already Signed Up!
              </div>
              <div
                v-if="user.type == 'food_service_full' && subscription && subscription.ends_at"
                class="text-muted mr-3"
              >
                Plan expires on {{ moment(subscription.ends_at).format('LL') }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="subscription && !subscription.ends_at"
          class="col-12 col-md-12 d-flex align-items-stretch"
        >
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Cancel
              </h4>
            </div>
            <div class="card-body">
              <p>Cancelling your subscription will leave your account active but without access to any resources.</p>
            </div>
            <div class="card-footer d-flex justify-content-center align-items-center">
              <div
                class="btn btn-danger btn-md text-light"
                @click="cancel"
              >
                Cancel Subscription
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Subscription from '../services/subscription.js';
import Plans        from '../services/plans.js';
import Modal        from '../components/Modal';
import moment       from 'moment';

export default {
  name: 'Subscriptions',
  components: { Modal },
  data () {
    return {
      plans: {},
      plan: null
    }
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    subscription() {
      return this.user ? (this.user.subscription || null) : null;
    },
    discountedRate() {
      if (this.plan && this.coupon) {

        let plan = this.plan;
        let coupon = this.coupon;

        if (coupon.amount_off) {

          let price = plan.price_raw - coupon.amount_off_raw;

          price = price > 0 ? price : 0;

          return (price/100).toFixed(2);
        }

        if (coupon.percent_off) {

          let price = plan.price_raw * (coupon.percent_off/100);

          return (price/100).toFixed(2);

        }

        return plan.price;
      }

      return this.plan.price || null;
    }
  },
  mounted(){
    this.loadPlans();
  },
  methods: {
    loadPlans() {
      Plans.get().then((res) => {
        this.plans = res.data;

        switch (this.user.type) {
        case 'food_service_limited':
          this.plan = this.plans.food_service_limited || null;
          break;
        case 'food_service_full':
          this.plan = this.plans.food_service_full || null;
          break;
        case 'individual':
          this.plan = this.plans.individual || null;
          break;
        default:
          this.plan = null;
          break;
        }
      }).catch((err) => {
        this.$store.dispatch('notifications/setError', 'Unable to load plans.  Please reload and try again.');
      });
    },

    cancel() {
      this.$store.dispatch('notifications/clear');
      this.$store.dispatch('user/cancelSubscription').then(res => {
        this.$store.dispatch('notifications/setSuccess', 'Your subscription has been cancelled.');
      }).catch(err =>{
        this.$store.dispatch('notifications/setError', 'There was an error cancelling your subscription');
        this.$store.dispatch('notifications/setErrorBag', err.response.data.errors || null);
      })
    },
    resume() {
      this.$store.dispatch('notifications/clear');
      this.$store.dispatch('user/resumeSubscription').then(res => {
        this.$store.dispatch('notifications/setSuccess', 'Subscription resumed');
      }).catch(err => {
        this.$store.dispatch('notifications/setError', 'There was an error resuming your subscription');
        this.$store.dispatch('notifications/setErrorBag', err.response.data.errors || null);
      })
    },
    swap(userType) {
      this.$store.dispatch('notifications/clear');
      this.$store.dispatch('user/swapSubscription', userType).then(() => {
        this.$store.dispatch('notifications/setSuccess', 'Your plan was successfully updated');
      }).catch(err => {
        this.$store.dispatch('notifications/setError', 'There was an error updating your subscription');
        this.$store.dispatch('notifications/setErrorBag', err.response.data.errors || null);
      });
    },
    moment(...args) {
      return moment(...args);
    }
  }
}
</script>

<style lang="scss" scoped>
    $light-gray: #bebebe;
    p {
        font-size: 1.2rem;
    }
    .checkmark{
        color: green;
    }
    .crossmark {
        color: red;
    }
    .card-footer {
        min-height: 64px;
    }
    .status-card {
        padding: 40px;
        background: rgba(40, 167, 69, 0.11);
    }

    .mock-cc {
        display: flex;
        flex-direction: column;
        max-width: 125px;
        min-width: 100px;
        color: #fafafa;
        background: linear-gradient(to right, #6de055de 0%, #589836 47%, #5f9f3b 100%);
        box-shadow: 0px 0px 2px 0px rgba(0,0,0,1);

        .card-name {
            align-self: flex-start;
            padding-bottom: 40px;
        }
        .card-digits {
            align-self: flex-end;
            padding-bottom: 3px;
            padding-right: 5px;
        }

    }

    .plan-price-digit {
        font-size: 40px;
    }

    .shadow {
        -moz-box-shadow:    inset 0 0 10px $light-gray;
        -webkit-box-shadow: inset 0 0 10px $light-gray;
        box-shadow:         inset 0 0 10px $light-gray;
    }

    .update-card-button {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        max-width: 33%;
    }
</style>
